import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PluginContextService } from '../../../core/services/plugin-context.service';

import { DetailsModalComponent } from '../organization/details-modal/details-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-text-attribute-visualizer',
  standalone: true,
  imports: [],
  templateUrl: './text-attribute-visualizer.component.html',
  styleUrl: './text-attribute-visualizer.component.css'
})

export class TextAttributeVisualizerComponent implements OnInit {
  @Input() mapentityid!: string;
  @Input() prop!: string;

  entity: any;
  name: string | null = null;
  userId: string | null = null;
  collapsed: boolean = false;
  constructor(
    private pluginContext: PluginContextService,
    private sanitizer: DomSanitizer,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    const entity = this.pluginContext.getDataContext().getMapEntity(this.mapentityid);
    this.entity = entity.arcLiveMapEntity;
    if (this.entity.data && this.entity.data.userInfo) {
      this.name = this.entity.data.userInfo.name;
      this.userId = this.entity.data.userInfo.userId;
    }
  }

  getSanitizedHtml(): SafeHtml {
    const value = this.entity?.[this.prop] ?? '';
    const html = value.replace(
      /(https?:\/\/[^\s]+)/g,
      (url: string) => `<a href="${url}" target="_blank" rel="noopener">${url}</a>`
    );
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  viewUserInfo(userInfo: any): void {
    const title = 'User Info';
    this.openDetailsModal(title, userInfo, false);
  }

  private openDetailsModal(
      title: string,
      data: any,
      shouldCallApi: boolean
    ) {
      const modalRef = this.modalService.open(DetailsModalComponent, {
        size: 'lg',
        centered: true,
        backdrop: 'static',
        windowClass: 'response-modal-top zindex',
        backdropClass: 'response-modal-backdrop-top',
        keyboard: false,
      });
  
      modalRef.componentInstance.title = title;
      modalRef.componentInstance.userInfo = data;
      modalRef.componentInstance.showCancel = false;
      modalRef.componentInstance.shouldCallApi = shouldCallApi;
  
      return modalRef.result;
    }
}